import React from 'react';
import PropTypes from 'prop-types';
import BaseTransition from './BaseTransition';

const transitionStyles = {
  entering: {
    opacity: 0
  },
  entered: {
    opacity: 1
  },
  exiting: {
    opacity: 0
  }
};

const FadeTransition = props => {
  const { duration, ...rest } = props;
  const baseStyles = {
    transition: `${duration}ms ease`,
    transitionProperty: 'opacity',
    willChange: 'opacity'
  };
  return (
    <BaseTransition
      duration={duration}
      {...rest}
      baseStyles={baseStyles}
      transitionStyles={transitionStyles}
    />
  );
};

FadeTransition.propTypes = {
  duration: PropTypes.number
};

FadeTransition.defaultProps = {
  duration: 0
};

export default FadeTransition;
